module.exports = __webpack_public_path__ + "static/media/icon.63ee281c.png";